import React from 'react';
import dayjs from 'core/utils/dayjs';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useMessageClass } from 'core/modules/Onboarding/components/SlideMessage/hooks/useMessageClass';
import { parseBonusButton } from 'core/modules/BonusButton/utils/parseBonusButton';
import config from 'core/modules/BonusButton/configs';
import './BonusButtonSlideMessage.scss';

function BonusButtonSlideMessage({ placement }) {
  useMessageClass(true);
  const {
    dateFormat, getTitle, getTermsText, getPreTitle,
  } = config.slideMessageConfig;
  const {
    endDate, maxRewardAvailable, minSpendToQualify, brandCurrency,
  } = parseBonusButton(placement);
  const endDateFormated = dayjs(endDate).format(dateFormat);

  const preTitle = getPreTitle();
  const title = getTitle(minSpendToQualify, endDateFormated, maxRewardAvailable, brandCurrency);
  const termsText = getTermsText();

  return (
    <div className="mn_slideMessage mn_bonusButton">
      <div className="mn_details">
        <div className="mn_preTitle">{preTitle}</div>
        <div className="mn_title">{title}</div>
        {termsText && <div className="mn_terms">{termsText}</div>}
      </div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><BonusButtonSlideMessage {...props} /></ComponentErrorBoundary>;
